import script from "./NewContactForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NewContactForm.vue?vue&type=script&setup=true&lang=js"

import "./NewContactForm.vue?vue&type=style&index=0&id=1a51f768&lang=css"

const __exports__ = script;

export default __exports__